import {
	NUMBER_CF_TYPE,
	STORY_POINTS_TYPE,
	STORY_POINT_ESTIMATE_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FormatRule, EvaluateHandler } from '../../../evaluate-format-rule/types.tsx';
import type { SUPPORTED_NUMBER_TYPES } from '../types.tsx';

type NumberField = {
	fieldId: string;
	type: SUPPORTED_NUMBER_TYPES;
	value: number | null;
};

const evaluateHandler: EvaluateHandler<NumberField> = {
	EQUALS: (field, value) => Boolean(field.value && field.value === Number(value)),
	DOES_NOT_EQUAL: (field, value) => Boolean(field.value && field.value !== Number(value)),
	GREATER_THAN: (field, value) => Boolean(field.value && field.value > Number(value)),
	GREATER_THAN_OR_EQUALS: (field, value) => Boolean(field.value && field.value >= Number(value)),
	LESS_THAN: (field, value) => Boolean(field.value && field.value < Number(value)),
	LESS_THAN_OR_EQUALS: (field, value) => Boolean(field.value && field.value <= Number(value)),
	IS_EMPTY: (field) => !field.value,
	IS_NOT_EMPTY: (field) => Boolean(field.value),
};

const evaluateFormatRule: FormatRule<NumberField> = ({ field, operator, value }) => {
	const evaluateHandlerFn = evaluateHandler[operator];
	if (!evaluateHandlerFn) return false;
	return evaluateHandlerFn(field, value);
};

export const numberEvaluateFormatRule = {
	[NUMBER_CF_TYPE]: evaluateFormatRule,
	[STORY_POINTS_TYPE]: evaluateFormatRule,
	[STORY_POINT_ESTIMATE_CF_TYPE]: evaluateFormatRule,
};
